"use client";

import { c as _c } from "react/compiler-runtime";
import DelegationMappingTool from "@/components/mapping-tools/DelegationMappingTool";
import { useSetTitle } from "@/contexts/TitleContext";
import styles from "@/styles/Home.module.scss";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
export default function DelegationMappingToolPage() {
  const $ = _c(20);
  useSetTitle("Delegation Mapping Tool | Tools");
  const [html, setHtml] = useState("");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      fetch("https://6529bucket.s3.eu-west-1.amazonaws.com/seize_html/delegation-mapping-tool/how-to-use.html").then(response => {
        if (response.status === 200) {
          response.text().then(htmlText => {
            setHtml(htmlText);
          });
        }
      });
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Row className="pt-4"><Col xs={{
        span: 12
      }} sm={{
        span: 12
      }} md={{
        span: 10,
        offset: 1
      }} lg={{
        span: 8,
        offset: 2
      }}><h1 className="text-center">Delegation Mapping Tool</h1></Col></Row>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Row className="pt-2"><Col xs={{
        span: 12
      }} sm={{
        span: 12
      }} md={{
        span: 10,
        offset: 1
      }} lg={{
        span: 8,
        offset: 2
      }}><h5>Overview</h5></Col></Row>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      span: 12
    };
    t5 = {
      span: 12
    };
    t6 = {
      span: 10,
      offset: 1
    };
    t7 = {
      span: 8,
      offset: 2
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Row><Col xs={t4} sm={t5} md={t6} lg={t7}>The Delegation Mapping tool allows anyone to easily upload a CSV file with addresses to receive delegated addresses in return (from the NFTDelegation contract).{" "}<a href="#how-to-use">How to use this tool?</a></Col></Row>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t11;
  let t12;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      span: 12
    };
    t10 = {
      span: 10,
      offset: 1
    };
    t11 = {
      span: 8,
      offset: 2
    };
    t12 = {
      span: 6,
      offset: 3
    };
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t9;
  } else {
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t9 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Container fluid={true}><Row><Col><Container>{t2}{t3}{t8}<Row><Col xs={t9} sm={t10} md={t11} lg={t12}><Container className="pt-5 pb-5"><Row><Col><DelegationMappingTool /></Col></Row></Container></Col></Row></Container></Col></Row></Container>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  let t15;
  let t16;
  let t17;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      span: 12
    };
    t15 = {
      span: 10,
      offset: 1
    };
    t16 = {
      span: 8,
      offset: 2
    };
    t17 = {
      span: 6,
      offset: 3
    };
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
  } else {
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
  }
  let t18;
  if ($[18] !== html) {
    t18 = <main className={styles.main}>{t13}<Container id="how-to-use" className="pt-1 pb-5"><Row><Col className={styles.htmlContainer} xs={t14} sm={t15} md={t16} lg={t17} dangerouslySetInnerHTML={{
            __html: html
          }} /></Row></Container></main>;
    $[18] = html;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  return t18;
}